import { RegisteredComponent } from "@builder.io/sdk-react";
import { textualFormConfig } from "./textualFormConfigs";
import { generalFormConfig } from "./generalFormConfig";

export const genericTextualInputBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Form:Input",
  friendlyName: "Generic textual input",
  description:
    "The following state variables are expected: onChange and onBlur.",
  override: true,
  noWrap: true,
  image:
    "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fad6f37889d9e40bbbbc72cdb5875d6ca",
  canHaveChildren: false,
  static: true,
  defaultStyles: {
    width: "100%",
    flexShrink: "1",
    outline: "none",
  },
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  inputs: [
    {
      name: "type",
      type: "enum",
      localized: false,
      required: true,
      defaultValue: "text",
      enum: [
        {
          label: "Text",
          value: "text",
        },
        {
          label: "Number",
          value: "number",
        },
        {
          label: "Email",
          value: "email",
        },
        {
          label: "Month",
          value: "month",
        },
        {
          label: "Password",
          value: "password",
        },
        {
          label: "Search",
          value: "search",
        },
        {
          label: "Time",
          value: "time",
        },
        {
          label: "URL",
          value: "url",
        },
        {
          label: "Week",
          value: "week",
        },
        {
          label: "Date",
          value: "date",
        },
        {
          label: "Date with time",
          value: "datetime-local",
        },
      ],
    },
    {
      name: "step",
      type: "number",
      localized: false,
      required: false,
      defaultValue: 1,
      showIf: (options) => options.get("type") === "number",
    },
    {
      name: "min",
      type: "number",
      localized: false,
      required: false,
      defaultValue: 0,
      showIf: (options) => options.get("type") === "number",
    },
    {
      name: "max",
      type: "number",
      localized: false,
      required: false,
      showIf: (options) => options.get("type") === "number",
    },
    {
      name: "value",
      type: "string",
      required: true,
      localized: false,
    },
    {
      name: "onBlur",
      type: "javascript",
      localized: false,
    },
    {
      name: "onChange",
      type: "javascript",
      localized: false,
    },
    {
      name: "onInvalid",
      type: "javascript",
      localized: false,
    },
    {
      name: "onChangeState",
      type: "javascript",
      localized: false,
    },
    ...(generalFormConfig ?? []),
    ...(textualFormConfig ?? []),
  ],
};
